import { Image} from "react-bootstrap";
import {
    BoardMembersSection,
    BoardMemberImage,
    BoardMemberDescription,
} from '../membersStyle';
import BoardMembersImage from '../../../../assests/images/board_member.webp'
import { useEffect, useState } from "react";
import { useSelector,useDispatch } from "react-redux";
import { aboutMembersHandler } from "../../../../redux/slices/members/about-members";

const BoardMembers = () => {
    const [boardMemberList, setBoardMemberList] = useState([])
    const aboutMembersData = useSelector((state:any) => state?.aboutMembers?.data)
    const dispatch:any = useDispatch();

     useEffect(() => {
          dispatch(aboutMembersHandler())
      },[])
      
    useEffect(() => {
     if(aboutMembersData?.data){
        setBoardMemberList(aboutMembersData.data.boardMembers);
     }
    },[aboutMembersData])

    return (
    <>
        {boardMemberList?.map((member:any, index:number) => (
            <BoardMembersSection key={index+1}>
                <BoardMemberImage><Image src={BoardMembersImage} alt={member.profileImg}/></BoardMemberImage>
                <BoardMemberDescription>
                    <strong>{member.name} </strong> {member.about}
                </BoardMemberDescription>
            </BoardMembersSection>
        ))}
    </>
    
) 
};
export default BoardMembers; 